import { Skeleton, styled, Typography } from "@mui/material"

export const Wrapper = styled("div", {
    shouldForwardProp: prop => prop !== "isMainCount",
})(({ isMainCount, theme }) => ({
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 100,
    border: isMainCount && `1px solid ${theme.palette["common/black_states"].main}`,
    boxSizing: "border-box",
    display: "flex",
    flexWrap: "wrap",
    height: "fit-content",
    minHeight: 32,
    minWidth: 32,
    maxHeight: 32,
    padding: isMainCount && theme.spacing(1, 2),
    fontSize: 0,
    textAlign: "center",
}))

export const Text = styled(Typography, {
    shouldForwardProp: prop => prop !== "isMainCount",
})(({ isMainCount }) => ({
    fontSize: 16,
    whiteSpace: isMainCount && "nowrap",
}))

export const TextTotal = styled(Typography)(() => ({
}))

export const CatalogItemsCountSkeleton = styled(Skeleton, {
    shouldForwardProp: prop => prop !== "isMainCount",
})(({ isMainCount, theme }) => ({
    height: 32,
    padding: isMainCount && theme.spacing(2),
    transform: "scale(1)",
    width: 42,
}))